/**
 * Widget bundle version (short commit hash) sent with every chat message so
 * N8N and the backend can attribute each message to the bundle that sent it.
 * Undefined outside Vite widget builds (e.g. unit tests), in which case it is omitted.
 */
export function getWidgetVersion(): string | undefined {
  return import.meta.env.VITE_WIDGET_VERSION || undefined;
}
